/**
 * @fileoverview Slice Redux para gerenciamento de estado do modal de promoções.
 * Controla abertura/fechamento do modal de promoções seguindo o padrão dos outros modais.
 * 
 * @module promotionSlice
 * @requires @reduxjs/toolkit
 * @since 1.0.0
 */

import { createSlice } from '@reduxjs/toolkit';

/**
 * Estado inicial do slice de promoções.
 * @type {Object}
 * @property {boolean} isOpen - Estado de abertura do modal
 * @property {Object|null} promotionContext - Contexto da promoção ativa durante navegação
 */
const initialState = {
  isOpen: false,
  promotionContext: null,
};

/**
 * Slice Redux para gerenciamento do modal de promoções.
 * @type {Object}
 */
const promotionSlice = createSlice({
  name: 'promotion',
  initialState,
  reducers: {
    /**
     * Abre o modal de promoções.
     * @function openPromotionManager
     * @param {Object} state - Estado atual
     * @returns {void}
     */
    openPromotionManager: (state) => {
      state.isOpen = true;
    },
    /**
     * Fecha o modal de promoções.
     * @function closePromotionManager
     * @param {Object} state - Estado atual
     * @returns {void}
     */
    closePromotionManager: (state) => {
      state.isOpen = false;
    },
    /**
     * Define o contexto da promoção ativa.
     * @function setPromotionContext
     * @param {Object} state - Estado atual
     * @param {Object} action - Action com payload da promoção
     * @returns {void}
     */
    setPromotionContext: (state, action) => {
      state.promotionContext = action.payload;
    },
    /**
     * Limpa o contexto da promoção.
     * @function clearPromotionContext
     * @param {Object} state - Estado atual
     * @returns {void}
     */
    clearPromotionContext: (state) => {
      state.promotionContext = null;
    },
  },
});

export const { openPromotionManager, closePromotionManager, setPromotionContext, clearPromotionContext } = promotionSlice.actions;
export default promotionSlice.reducer;